var BaggageInfoResponse = /** @class */ (function () {
    function BaggageInfoResponse() {
        this.isOk = false;
        this.outboundInfo = [];
        this.inboundInfo = [];
        this.allAirlineInfoText = [];
        this.allGepaeckInfoText = [];
        this.outboundGepaeckInfoText = [];
        this.inboundGepaeckInfoText = [];
    }
    BaggageInfoResponse.prototype.setIsOk = function (state) {
        this.isOk = state;
    };
    BaggageInfoResponse.prototype.getIsOk = function () {
        return this.isOk;
    };
    BaggageInfoResponse.prototype.setOutboundBaggageAirlineInfo = function (legNr, baggageAirlineInfo) {
        this.outboundInfo[legNr] = baggageAirlineInfo;
    };
    BaggageInfoResponse.prototype.setInboundBaggageAirlineInfo = function (legNr, baggageAirlineInfo) {
        this.inboundInfo[legNr] = baggageAirlineInfo;
    };
    BaggageInfoResponse.prototype.hasOutboundBaggageAirlineInfo = function (legNr) {
        return typeof (this.outboundInfo[legNr]) !== 'undefined';
    };
    BaggageInfoResponse.prototype.hasInboundBaggageAirlineInfo = function (legNr) {
        return typeof (this.inboundInfo[legNr]) !== 'undefined';
    };
    BaggageInfoResponse.prototype.getOutboundBaggageAirlineInfo = function (legNr) {
        return this.outboundInfo[legNr];
    };
    BaggageInfoResponse.prototype.getAllOutboundBaggageAirlineInfo = function () {
        return this.outboundInfo;
    };
    BaggageInfoResponse.prototype.getInboundBaggageAirlineInfo = function (legNr) {
        return this.inboundInfo[legNr];
    };
    BaggageInfoResponse.prototype.getAllInboundBaggageAirlineInfo = function () {
        return this.inboundInfo;
    };
    BaggageInfoResponse.prototype.addAllAirlineBaggageInfoText = function (allAirlineInfoText) {
        this.allAirlineInfoText.push(allAirlineInfoText);
    };
    BaggageInfoResponse.prototype.getAllAirlineBaggageInfoText = function () {
        return this.allAirlineInfoText;
    };
    BaggageInfoResponse.prototype.addAllGepaeckInfoText = function (allGepaeckInfoText) {
        this.allGepaeckInfoText.push(allGepaeckInfoText);
    };
    BaggageInfoResponse.prototype.getAllGepaeckInfoText = function () {
        return this.allGepaeckInfoText;
    };
    BaggageInfoResponse.prototype.setOutboundGepaeckInfoText = function (legNr, infoText) {
        this.outboundGepaeckInfoText[legNr] = infoText;
    };
    BaggageInfoResponse.prototype.setInboundGepaeckInfoText = function (legNr, infoText) {
        this.inboundGepaeckInfoText[legNr] = infoText;
    };
    BaggageInfoResponse.prototype.getOutboundGepaeckInfoText = function () {
        return this.outboundGepaeckInfoText;
    };
    BaggageInfoResponse.prototype.getInboundGepaeckInfoText = function () {
        return this.inboundGepaeckInfoText;
    };
    return BaggageInfoResponse;
}());
export { BaggageInfoResponse };
